import React from 'react'
import { Button, Divider, Segment, Header, Grid } from 'semantic-ui-react'

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

import clyde1941 from '../images/articlePictures/clyde1941.png'
import clydeEdnaMeet42 from '../images/articlePictures/clydeEdnaMeet42.png'
import clydeKimScooter51 from '../images/articlePictures/clydeKimScooter55.png'
import clydeEdnaBabyKim from '../images/articlePictures/clydeEdnaBabyKim.png'
import familyAndBill55 from '../images/articlePictures/familyAndBill55.png'
import sixFiftyCourt from '../images/articlePictures/sixFiftyCourt.png'
import twealthCourt56 from '../images/articlePictures/twealthCourt56.png'
import gailKaren60 from '../images/articlePictures/gailKaren60.png'
import jay58 from '../images/articlePictures/jay58.png'
import familyPortrait79 from '../images/articlePictures/familyPortrait79.png'
import familyPortrait91 from '../images/articlePictures/familyPortrait91.png'

const RichardsonGainesville = () => (

<React.Fragment>
<Segment  style={{ padding: '0em 0em' }} vertical>
    <Grid celled='internally' columns='equal' stackable>
        <Grid.Row textAlign='center'>
            <Grid.Column  style={{ paddingBottom: '0em', paddingTop: '0em' }}>
                <br/>
                <Header as='h3' style={{ fontSize: '2em' }}>The Richardson's in Gainesville, Florida  <br/> (1938-1979) </Header>
                <br/>

            </Grid.Column>
        </Grid.Row>

        <Grid.Row textAlign='left'>
            <Grid.Column  style={{ paddingBottom: '1em', paddingTop: '.5em' }} >
                <p class="sidePadding" style={{ fontSize: '1.33em' }}>
                <br/>
                The Richardson family had its start in Gainesville during July of 1938.  Clyde moved there from Fort Myers to work for David Kite, his brother-in-law.  He moved in with his sister Bert and Dave in a small house in the 500 block of 2nd Avenue near downtown.  Clyde drove a truck for Kite Transfer.
                <br/>
                <br/>
	            <SimpleReactLightbox>
                    <SRLWrapper>
                        <img src={clyde1941} class="articlePhoto" alt="1941 – Clyde Richardson" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                <br/>
                On Sunday, December 7, 1941, Clyde was walking up to a small service station on University Avenue and 6th Street when he heard about the Japanese bombing Pearl Harbor.  He went to the Navy Recruiters and enlisted.  The recruiter told him that he had to have his parents sign for him.  He told him that he was 30 years old, but they said that didn’t matter.  Clyde went outside and signed his parent’s names and they accepted him.
                <br/>
                <br/>
                On December 6, 1942, he met Edna Frank over a checker game at the YWCA in Brooklyn.  They were married on January 26, 1946.
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={clydeEdnaMeet42} class="articlePhoto" alt="1942 - Clyde Richardson  &amp; Edna Frank" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                <br/>
                The day after the wedding they boarded a train for Florida.  They rented a house on Court Street (NW 3rd Avenue) for a period before moving 4 houses down the street to 650 Court Street (512 NW 3rd Avenue), a two bedroom house and paid Dave $20.00 per month.
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={sixFiftyCourt} class="articlePhoto" alt="650 Court Street" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                <br/>
                <br/>
                During the war, Clyde had sent money to Dave to save for him.  Dave advised Clyde to use that money to buy a truck.  Kite Transfer contracted to deliver freight for different customers.  One of their largest customers was Sears.  After Dave retired, Clyde continued to drive for himself.  He hired a man by the name of Louis for $20.00 per week to help him.
                <br/>
                <br/>
                On May 10, 1947, Clyde and Edna had their first child.  They had a son, Kim Frank.
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={clydeEdnaBabyKim} class="articlePhoto" alt="1947 – Edna, Clyde &amp; Kim" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                <br/>
                <br/>
                In 1949 they had their second child, Tara, who died a couple days later.
                <br/>
                <br/>
                During 1950, they bought a 1939 Chevy truck from Dave.  In 1951, a friend borrowed Clyde’s work truck and threw a rod.  Clyde used the wood to build Kim a playhouse.  He also talked Sears into hiring him full time for $50.00 per week.  That year they traded in the truck for a 1949 Ford.
                <br/>
                <br/>
                On October 7, 1954, they had a daughter, Gail Dorothy
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={clydeKimScooter51} class="articlePhoto" alt="1955 – Clyde &amp; Kim" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                <br/>
                In 1955 Clyde bought a used Cushman scooter.  He rode it to work.
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={familyAndBill55} class="articlePhoto" alt="1955 - Clyde, Edna, Gail &amp; Kim (far right)" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                <br/>
                <br/>
                 The small two bedroom house was now growing too small.  On January 1, 1956 they moved into a new house on North East 12th Court.
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={twealthCourt56} class="articlePhoto" alt="549 NE 12th Court" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                <br/>
                <br/>
                Clyde continued to work for Sears as the Warehouse Manager.  On March 16, 1958, the family expanded by one more with the addition of Jay Clyde.
                <br/>
                <br/>
                <div class="ui two column grid">
                <div class="column">
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={jay58} class="articlePhoto" alt="1958 – Jay" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                </div>
                <div class="column">
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={gailKaren60} class="articlePhoto" alt="1960 – Gail &amp; Karen" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                </div>
                </div>
                <br/>
                <br/>
                On November 5, 1959 Karen Lucy was born.
                <br/>
                <br/>
                In 1959 Edna went to work for the University of Florida.  
                <br/>
                <br/>
                In June of 1973 Kim Graduated from the University of Florida with BSBA in Business Administration.
                <br/>
                <br/>
                Kim moved to Houston, Texas in April 10, 1975.  Gail married Don Orth in April 10, 1976 and had three children, Jerett, Brandy, and Tiffany.  1979 saw Jay moving to Houston.
                <br/>
                <br/>
                <div class="ui two column grid">
                <div class="column">
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={familyPortrait79} class="articlePhoto" alt="1979 –  Family Portrait" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                </div>
                <div class="column">
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <img src={familyPortrait91} class="articlePhoto" alt="1991 – Family Portrait" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                </div>
                </div>
                </p>
            </Grid.Column>
        </Grid.Row>
        </Grid>
    </Segment>
</React.Fragment>
)

export default RichardsonGainesville